import { render, staticRenderFns } from "./DeliveryAddressForm.vue?vue&type=template&id=30a848da&"
import script from "./DeliveryAddressForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryAddressForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports